import React, { forwardRef } from "react";
import styles from "./Select.module.css";

const SelectObjetos = forwardRef(
  (
    {
      id,
      label,
      options,
      value,
      onChange,
      hasError,
      disabled,
      valueKey,
      labelKey,
      title
    },
    ref
  ) => {
    return (
      <div className={styles.select_container}>
        <label className={styles.select_label} htmlFor={id}>
          {label}
        </label>
        <select
          className={`${styles.select} ${
            hasError ? ` ${styles.error} ${styles.select} ` : ""
          }`}
          alt={title}
          title={title}
          ref={ref}
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          <option
            value=""
            alt="Nenhum item selecionado"
            title="Nenhum item selecionado"
          >
            ...
          </option>
          {options &&
            options.map((option) => (
              <option
                alt={option[labelKey]}
                title={option[labelKey]}
                key={option[valueKey]}
                value={option[valueKey]}
              >
                {option[labelKey]}
              </option>
            ))}
        </select>
      </div>
    );
  }
);

export default SelectObjetos;
